import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BuildIcon from "@mui/icons-material/Build";

const NotificationBell = () => {
	return (
		<Tooltip title="Notifications — In Development" arrow>
			<Box sx={{ position: "relative", display: "inline-block", pr: 1 }}>
				<IconButton
					disabled
					sx={{
						color: "#1D54A2 !important",
						textTransform: "none",
						backgroundColor: "#FFFFFF !important",
						opacity: 0.6,
						p: 0.5,
					}}
				>
					<NotificationsIcon sx={{ fontSize: "1.8rem" }} />
				</IconButton>
				<Box
					sx={{
						position: "absolute",
						top: 0,
						right: 4,
						width: 18,
						height: 18,
						borderRadius: "50%",
						backgroundColor: "#E65100",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						border: "2px solid #fff",
						pointerEvents: "none",
					}}
				>
					<BuildIcon sx={{ fontSize: 10, color: "#fff" }} />
				</Box>
			</Box>
		</Tooltip>
	);
};

export default NotificationBell;
